import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const AddonManagementRouteLazy = lazyWithRetry(() => import('./AddonManagement'));
export function AddonManagementRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <AddonManagementRouteLazy />
    </Suspense>
  );
}
